import React from 'react'
import Image from 'next/image'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { RxArrowTopRight } from 'react-icons/rx'
const graduatesByProgram = {
    'front-end': [
        { id: 'khazar-khalilov', nameKey: 'programs-page.graduate-names.khazar-khalilov', image: '/images/graduates/Khazar_Khalilov.jpg' },
        { id: 'nasir-rasulzada', nameKey: 'programs-page.graduate-names.nasir-rasulzada', image: '/images/graduates/Nasir_Rasulzada.jpg' },
        { id: 'aysu-abdullayeva', nameKey: 'programs-page.graduate-names.aysu-abdullayeva', image: '/images/graduates/Aysu_Abdullayeva.jpg' },
        { id: 'nurlan-hasanov', nameKey: 'programs-page.graduate-names.nurlan-hasanov', image: '/images/graduates/Nurlan_Hasanov.jpg' },
        { id: 'rahib-gurbanli', nameKey: 'programs-page.graduate-names.rahib-gurbanli', image: '/images/graduates/Rahib_Gurbanli.jpg' },
    ],
    'back-end': [
        { id: 'mahammad-taghiyev', nameKey: 'programs-page.graduate-names.mahammad-taghiyev', image: '/images/graduates/Mahammad_Taghiyev.jpeg' },
        { id: 'emin-haziyev', nameKey: 'programs-page.graduate-names.emin-haziyev', image: '/images/graduates/Emin_Haziyev.jpg' },
        { id: 'nurulla-ibadov', nameKey: 'programs-page.graduate-names.nurulla-ibadov', image: '/images/graduates/Nurulla_İbadov.jpg' },
        { id: 'kanan-karimli', nameKey: 'programs-page.graduate-names.kanan-karimli', image: '/images/graduates/Kanan_Karimli.jpg' },
        { id: 'namil-jafarli', nameKey: 'programs-page.graduate-names.namil-jafarli', image: '/images/graduates/Namil_Jafarli.jpg' },
        { id: 'shargiya-guluzada', nameKey: 'programs-page.graduate-names.shargiya-guluzada', image: '/images/graduates/Shargiya_Guluzada.jpg' },
        { id: 'ravan-guliyev', nameKey: 'programs-page.graduate-names.ravan-guliyev', image: '/images/graduates/Ravan_Guliyev.jpg' },
        { id: 'amin-baghiyev', nameKey: 'programs-page.graduate-names.amin-baghiyev', image: '/images/graduates/Amin_Baghiyev.jpg' },
        { id: 'omar-aghayev', nameKey: 'programs-page.graduate-names.omar-aghayev', image: '/images/graduates/Omar_Aghayev.jpg' },
        { id: 'ebru-bandaliyeva', nameKey: 'programs-page.graduate-names.ebru-bandaliyeva', image: '/images/graduates/Ebru_Bandaliyeva.jpeg' },
        { id: 'farid-najafov', nameKey: 'programs-page.graduate-names.farid-najafov', image: '/images/graduates/Farid_Najafov.jpg' },
        { id: 'aslan-mahmudlu', nameKey: 'programs-page.graduate-names.aslan-mahmudlu', image: '/images/graduates/Aslan_Mahmudlu.jpeg' },
        { id: 'mahir-khalilov', nameKey: 'programs-page.graduate-names.mahir-khalilov', image: '/images/graduates/Mahir_Khalilov.jpg' },
        { id: 'mirhuseyn-talibzada', nameKey: 'programs-page.graduate-names.mirhuseyn-talibzada', image: '/images/graduates/Mirhuseyn_Talibzada.jpg' },
    ],
}

const OurGraduates = ({ program }) => {
    const { t } = useTranslation()
    const graduates = graduatesByProgram[program] || []

    if (!graduates.length) {
        return null
    }

    function NextArrow(props) {
        const { className, style, onClick } = props
        return (
            <button
                type="button"
                aria-label="Next slide"
                className={`${className} z-10 !h-[32px] md:!h-[60px] !w-[32px] md:!w-[60px] transition hover:opacity-80 cursor-pointer rounded-full !bg-white flex items-center justify-center shadow-lg !before:hidden hover:text-white !right-[10px] md:!right-[30px]`}
                style={{ ...style, display: 'flex' }}
                onClick={onClick}
            >
                <IoIosArrowForward className="text-[16px] md:text-[24px]" />
            </button>
        )
    }

    function PrevArrow(props) {
        const { className, style, onClick } = props
        return (
            <button
                type="button"
                aria-label="Previous slide"
                className={`${className} z-10 !h-[32px] md:!h-[60px] !w-[32px] md:!w-[60px] transition hover:opacity-80 cursor-pointer rounded-full !bg-white flex items-center justify-center shadow-lg !before:hidden hover:text-white !left-[10px] md:!left-[30px]`}
                style={{ ...style, display: 'flex' }}
                onClick={onClick}
            >
                <IoIosArrowBack className="text-[16px] md:text-[24px]" />
            </button>
        )
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }

    return (
        <div className="w-full max-w-[90%] mx-auto py-[80px] md:py-[100px] overflow-hidden">
            <div className="flex flex-row items-center justify-between mb-[12px] md:mb-[32px] gap-4">
                <h2 className="text-[28px] xs:text-[32px] md:text-[64px] xl:text-[80px] font-[500] bg-gradient-to-b from-[#091F59] to-[#1A3884] bg-clip-text text-transparent">
                    {t('programs-page.our-graduates-title')}
                </h2>
                <Link href="/programs" aria-label={t('programs-page.our-graduates-see-more') || 'See more graduates'}>
                    <button
                        aria-label="See more graduates"
                        className="w-[48px] h-[48px] md:w-[200px] md:h-[56px] bg-white border-[1.4px] md:border border-[#1053F3] text-[#1053F3] text-[14px] md:text-[16px] font-[500] rounded-full flex items-center justify-center gap-2 hover:bg-[#1053F3] hover:text-white transition-all duration-300"
                    >
                        <RxArrowTopRight className="w-[20px] h-[20px] md:hidden" aria-hidden="true" />
                        <span className="hidden md:inline">{t('programs-page.programs-see-more')}</span>
                    </button>
                </Link>
            </div>
            <div className="relative">
                <Slider {...settings} className="our-campus-slider">
                    {graduates.map((item, index) => (
                        <div key={item.id} className="sm:px-[15px] px-[0px]">
                            <div className="group relative w-full !h-[350px] xs:!h-[480px] md:!h-[380px] lg:!h-[480px] rounded-[20px] overflow-hidden flex-shrink-0 cursor-pointer">
                                <Image
                                    src={item.image}
                                    alt={t(item.nameKey)}
                                    fill
                                    priority={index === 0}
                                    loading={index === 0 ? 'eager' : 'lazy'}
                                    className="object-cover object-top rounded-[20px]"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-white/70 backdrop-blur-sm p-[12px] max-h-[45%] overflow-y-auto translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out z-10">
                                    <h3 className="text-[16px] md:text-[24px] font-[500] text-black mb-[8px] text-center">
                                        {t(item.nameKey)}
                                    </h3>
                                    {/* <p className="text-[10px] md:text-[14px] lg:text-[16px] font-[400] text-black leading-[140%]">
                                        {t(`students-feedbacks.feedback-${item.id}-text`)}
                                    </p> */}
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    )
}

export default OurGraduates